function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M49.406 26.643V25.36c0-5.78-8.718-10.14-20.281-10.14-11.563 0-20.281 4.36-20.281 10.14v9.22c0 4.814 6.05 8.64 14.75 9.785v1.277c0 5.78 8.718 10.14 20.281 10.14 11.563 0 20.281-4.36 20.281-10.14v-9.22c0-4.77-5.858-8.6-14.75-9.778zm-29.5 13.206c-4.515-1.26-7.375-3.337-7.375-5.27v-3.244c1.88 1.332 4.4 2.407 7.375 3.128v5.386zm18.438-5.386c2.975-.721 5.494-1.796 7.375-3.128v3.243c0 1.934-2.86 4.01-7.375 5.27v-5.385zM34.656 50.91c-4.515-1.26-7.375-3.337-7.375-5.27v-.961c.606.023 1.22.039 1.844.039.894 0 1.768-.03 2.625-.08.953.34 1.923.63 2.906.866v5.406zm0-10.283c-1.831.27-3.68.405-5.531.403-1.851.002-3.7-.133-5.531-.403v-5.483c1.834.24 3.681.358 5.531.355 1.85.003 3.697-.116 5.531-.355v5.483zm14.75 11.062a38.127 38.127 0 01-11.062 0v-5.496a41.25 41.25 0 005.531.368c1.85.003 3.697-.115 5.531-.354v5.482zm11.063-6.05c0 1.934-2.86 4.01-7.375 5.271v-5.386c2.975-.721 5.494-1.795 7.375-3.127v3.243z",
    fill: "#23CEE6",
    style: {
      fill: "#f7931a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.8af066aee914e90836111c233e9e27da.svg";
export { ForwardRef as ReactComponent };